module.exports = __webpack_public_path__ + "static/media/astron-boy.video.2fdb94fc.ttf";